import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
import { USER_TYPES } from 'constants/index';
import RegistrationCard from './RegistrationCard';
import './styles.scss';

const ForEmployees: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const [seekerEmail, setSeekerEmail] = useState('');
	const [employerEmail, setEmployerEmail] = useState('');
	const [seekerEmailTouched, setSeekerEmailTouched] = useState(false);
	const [employerEmailTouched, setEmployerEmailTouched] = useState(false);
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const isSeekerEmailValid = emailRegex.test(seekerEmail);
	const isEmployerEmailValid = emailRegex.test(employerEmail);

	return (
		<section className="for-employees">
			<Container>
				<div className="d-flex flex-column flex-lg-row gap-3 gap-md-4">
					<RegistrationCard
						email={seekerEmail}
						setEmail={setSeekerEmail}
						emailTouched={seekerEmailTouched}
						setEmailTouched={setSeekerEmailTouched}
						isEmailValid={isSeekerEmailValid}
						onRegister={() =>
							navigate(
								`/signup?userType=${USER_TYPES.SEEKER}&email=${encodeURIComponent(seekerEmail)}`,
							)
						}
						imageSrc={IMAGE_PATHS.ForEmployeesImg}
						heading={translate('Header.registerInLessThan1Minute')}
						description={parse(sanitizeHtml(translate('Home.forEmployeesDescription')))}
						buttonLabel={translate('Common.joinAsSeeker')}
						buttonDisabled={!isSeekerEmailValid}
					/>
					<RegistrationCard
						email={employerEmail}
						setEmail={setEmployerEmail}
						emailTouched={employerEmailTouched}
						setEmailTouched={setEmployerEmailTouched}
						isEmailValid={isEmployerEmailValid}
						onRegister={() =>
							navigate(
								`/signup?userType=${USER_TYPES.COMPANY}&email=${encodeURIComponent(employerEmail)}`,
							)
						}
						imageSrc={IMAGE_PATHS.ForEmployersImg}
						heading={translate('Header.registerInLessThan1Minute')}
						description={parse(sanitizeHtml(translate('Home.forEmployersDescription')))}
						buttonLabel={translate('Common.joinAsEmployer')}
						buttonDisabled={!isEmployerEmailValid}
					/>
				</div>
			</Container>
		</section>
	);
};

export default ForEmployees;
